import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w100 fl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  key: 0,
  id: "tzAccounts",
  class: "ofs z1 shadowContent",
  style: {"max-height":"300px"}
}
const _hoisted_5 = ["id", "value", "onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.Util.isPresent(_ctx.selectedTzDic))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_TextfieldTag, {
              placeholder: `TimeZoneを選択`,
              style: {"border-bottom":"solid 1px #c8c8c8","min-width":"240px"},
              class: "fw600 fl fs14 pad5 skyblue arial",
              list: "tzAccounts",
              id: "tzList",
              value: _ctx.selectedTzDic.name,
              onInputValue: _ctx.filterLocation,
              onBlur: _ctx.blurField,
              onClickTextfield: _ctx.clickTextfield
            }, null, 8, ["value", "onInputValue", "onBlur", "onClickTextfield"]),
            _hoisted_3,
            (_ctx.showList && _ctx.timezonesArray)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timezonesArray, (tz, tzindex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: tzindex,
                      id: tz.value,
                      value: tz.name,
                      class: _normalizeClass(`pad10 fs14 hoverLgreyBg pointer arial`),
                      onClick: ($event: any) => (_ctx.selectTimezone(tz.name)),
                      style: {}
                    }, _toDisplayString(tz.name), 9, _hoisted_5))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}